/**
 * Title case and remove commas from name
 * @param {String} _name - Name to format
 * @returns {String} - Formatted name
 */
export const formatEntityName = (_name) => {
  // If name is not a string, return it as is
  if (typeof _name !== 'string') return _name;
  // Remove commas from name. Majority of names come from DB in format LAST, FIRST.
  let name = _name.replaceAll(',', '');

  // Name casing logic. Majority of names come from DB in ALL CAPS.
  const uncapitalized = [
    'and',
    'of',
    'the',
    'for',
    'as',
    'an',
    'by',
    'has',
    'to',
    'be',
    'de',
    'y',
  ];

  const capitalized = [
    'u.s.',
    'nasa',
    'esa',
    'nsf',
    'noaa',
    'usgs',
    'usda',
    'llc',
    'ltd',
    'u',
    'llp',
    'inc.',
    'inc',
  ];
  name = name
    .split(' ')
    .map((word, i) => {
      if (i !== 0 && uncapitalized.includes(word.toLowerCase())) {
        // If word is not the first word and is in the uncapitalized array, lowercase it
        return word.toLowerCase();
      } else if (capitalized.includes(word.toLowerCase())) {
        // If word is in the capitalized array, uppercase it
        return word.toUpperCase();
      } else if (word.includes('-')) {
        // If word contains a hyphen, split it and capitalize each word, then join with a hyphen
        return word
          .split('-')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join('-');
      } else if (word.includes('(')) {
        // If word contains parentheses, split it and capitalize the first word, then join
        return word
          .split('(')
          .map((w) => {
            // See if letters minus parens are equal to length of 3 or less, if so return word as is as it's likely an acronym
            if (w.replace(/[()]/g, '').length <= 3) return w;
            // Otherwise, capitalize the first letter and lowercase the rest
            return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
          })
          .join('(');
      } else {
        // Otherwise, capitalize the first letter and lowercase the rest
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    })
    .join(' ');

  return name;
};
